module.exports = __webpack_public_path__ + "static/media/kfz-meisterbetrieb.1eacd73a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/leiste/kfz-meisterbetrieb.png
// module id = 609
// module chunks = 0